// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"60":"ecf7331f","242":"6554105c","289":"7016f366","317":"aed7f0cc","326":"c5bda9d1","369":"569f0755","418":"e50627b4","440":"6a7696b3","510":"0a64c5f1","522":"f7bbeebe","796":"90411021"}[chunkId] + ".js";
};